/*
 * @Description: 防抖
 * @Author: Dai Guo
 * @Date: 2021-07-22 18:01:25
 * @LastEditors: Yu Wang
 * @LastEditTime: 2021-08-27 10:48:01
 */


import { useRef, useEffect, useCallback } from 'react';

function useDebounce(fn, delay = 500, dep = []) {
  const { current } = useRef({ fn, timer: null });
  useEffect(() => {
    current.fn = fn;
    // eslint-disable-next-line
  }, [fn]);

  return useCallback(function f(...args) {
    if (current.timer) {
      clearTimeout(current.timer);
    }
    current.timer = setTimeout(() => {
      current.fn.call(this, ...args);
    }, delay);
    // eslint-disable-next-line
  }, dep);
}

export default useDebounce;
